import backHoverIcon from './backHover.webp';
import backNormalIcon from './backNormal.webp';
import checkedIcon from './checked.svg';
import closeIcon from './close.webp';
import draftIcon from './draft.webp';
import errorIcon from './error.svg';
import publishedIcon from './published.webp';
import successIcon from './success.svg';
import uncheckedIcon from './unchecked.svg';
import warningIcon from './warn.svg';

export {
  backNormalIcon,
  backHoverIcon,
  draftIcon,
  publishedIcon,
  closeIcon,
  checkedIcon,
  uncheckedIcon,
  successIcon,
  warningIcon,
  errorIcon,
};
